import React, { lazy } from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
// import { ContactListPrivate } from './components';
const ContactListPrivate = lazy (() => import(/* webpackChunkName: "ContactListPrivate" */'./components'));
const contactList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  return <ContactListPrivate contactId={queryParams.id} />;
};

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/Contact-List-Private"
    component={contactList}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactListPrivate/routes.js